import apiClient from './client';

export interface EmailConnectorConfig {
  connectorId?: string;
  name: string;
  description?: string;
  isActive?: boolean;
  isDefault?: boolean;
  mailType?: 'gmail' | 'naver' | '';
  smtpHost: string;
  smtpPort: number;
  smtpSsl: boolean;
  smtpAccount: string;
  smtpPassword?: string;
  senderName?: string;
  senderEmail?: string;
  imapEnabled: boolean;
  imapHost?: string;
  imapPort?: number;
  imapSsl?: boolean;
  imapAccount?: string;
  imapPassword?: string;
  extraLabel?: string;
  updatedAt?: string;
}

export interface ReceivedMail {
  uid: number;
  subject: string;
  from: string;
  date: string;
  snippet: string;
}

const BASE = '/api/email-connectors';

export const emailConnectorApi = {
  async list(): Promise<EmailConnectorConfig[]> {
    const res = await apiClient.get<{ success: boolean; data: EmailConnectorConfig[] }>(BASE);
    return res.data.data;
  },
  async get(id: string): Promise<EmailConnectorConfig> {
    const res = await apiClient.get<{ success: boolean; data: EmailConnectorConfig }>(`${BASE}/${id}`);
    return res.data.data;
  },
  async save(config: EmailConnectorConfig): Promise<EmailConnectorConfig> {
    // 편집 시 백엔드가 기존 비밀번호를 조회할 수 있도록 id 필드 전달
    const payload = { ...config, id: config.connectorId };
    const res = await apiClient.post<{ success: boolean; data: EmailConnectorConfig }>(BASE, payload);
    return res.data.data;
  },
  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
  async testSmtp(id: string, config?: Partial<EmailConnectorConfig>): Promise<void> {
    const res = await apiClient.post<{ success: boolean; error?: string }>(`${BASE}/${id}/test-smtp`, config || {});
    if (!res.data.success) throw new Error(res.data.error || 'SMTP 연결 실패');
  },
  async sendTest(id: string, to: string): Promise<{ messageId: string; code: string; message: string }> {
    const res = await apiClient.post<{ success: boolean; data: { messageId: string; code: string; message: string }; error?: string }>(`${BASE}/${id}/send-test`, { to });
    if (!res.data.success) throw new Error(res.data.error || '발송 실패');
    return res.data.data;
  },
  async checkInbox(id: string, limit = 5): Promise<ReceivedMail[]> {
    try {
      const res = await apiClient.post<{ success: boolean; data: ReceivedMail[]; error?: string }>(`${BASE}/${id}/check-inbox`, { limit });
      if (!res.data.success) throw new Error(res.data.error || '수신 확인 실패');
      return res.data.data;
    } catch (err: any) {
      // axios 400 에러 시 response.data.error 추출
      const msg = err?.response?.data?.error || err?.message || '수신 확인 실패';
      throw new Error(msg);
    }
  },
};

export default emailConnectorApi;
